 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A0_FRONTCOVER from '@/components/00_frontcover'
 import A1_FM01 from '@/components/01_fm01'
 import A2_TITLE from '@/components/02_title'
 import A2I_COPY from '@/components/02i_copy'
 import A3_CONTENTS from '@/components/03_contents'
 import A4_INTRO from '@/components/04_intro'
 import A5_FM02 from '@/components/05_fm02'
 import A6_FM021 from '@/components/06_fm021'
 import A7_FM022 from '@/components/07_fm022'
 import A8_FM023 from '@/components/08_fm023'
 import A9_FM024 from '@/components/09_fm024'
 import A0_FM025 from '@/components/10_fm025'
 import A1_FM026 from '@/components/11_fm026'
 import A2_FM027 from '@/components/12_fm027'
 import A3_FM028 from '@/components/13_fm028'
 import A4_FM029 from '@/components/14_fm029'
 import A5_FM0210 from '@/components/15_fm0210'
 import A6_FM0211 from '@/components/16_fm0211'
 import A7_FM03 from '@/components/17_fm03'
 import A8_FM031 from '@/components/18_fm031'
 import A9_FM032 from '@/components/19_fm032'
 import A0_FM033 from '@/components/20_fm033'
 import A1_FM034 from '@/components/21_fm034'
 import A2_FM035 from '@/components/22_fm035'
 import A3_FM036 from '@/components/23_fm036'
 import A4_FM037 from '@/components/24_fm037'
 import A5_FM038 from '@/components/25_fm038'
 import A6_FM039 from '@/components/26_fm039'
 import A7_FM0310 from '@/components/27_fm0310'
 import A8_FM0311 from '@/components/28_fm0311'
 import A9_FM0312 from '@/components/29_fm0312'
 import A0_FM0313 from '@/components/30_fm0313'
 import A1_FM0314 from '@/components/31_fm0314'
 import A2_FM04 from '@/components/32_fm04'
 import A3_FM041 from '@/components/33_fm041'
 import A4_FM042 from '@/components/34_fm042'
 import A5_FM043 from '@/components/35_fm043'
 import A6_FM044 from '@/components/36_fm044'
 import A7_FM045 from '@/components/37_fm045'
 import A8_CHAPTER01 from '@/components/38_chapter01'
 import A9_CHAPTER011 from '@/components/39_chapter011'
 import A0_CHAPTER012 from '@/components/40_chapter012'
 import A1_CHAPTER013 from '@/components/41_chapter013'
 import A2_CHAPTER014 from '@/components/42_chapter014'
 import A3_CHAPTER015 from '@/components/43_chapter015'
 import A4_CHAPTER016 from '@/components/44_chapter016'
 import A5_CHAPTER017 from '@/components/45_chapter017'
 import A6_CHAPTER018 from '@/components/46_chapter018'
 import A7_CHAPTER019 from '@/components/47_chapter019'
 import A8_CHAPTER0110 from '@/components/48_chapter0110'
 import A9_CHAPTER0111 from '@/components/49_chapter0111'
 import A0_CHAPTER0112 from '@/components/50_chapter0112'
 import A1_CHAPTER0113 from '@/components/51_chapter0113'
 import A2_CHAPTER0114 from '@/components/52_chapter0114'
 import A3_CHAPTER0115 from '@/components/53_chapter0115'
 import A4_CHAPTER0116 from '@/components/54_chapter0116'
 import A5_CHAPTER0117 from '@/components/55_chapter0117'
 import A6_CHAPTER0118 from '@/components/56_chapter0118'
 import A7_CHAPTER0119 from '@/components/57_chapter0119'
 import A8_CHAPTER0120 from '@/components/58_chapter0120'
 import A9_CHAPTER02 from '@/components/59_chapter02'
 import A0_CHAPTER021 from '@/components/60_chapter021'
 import A1_CHAPTER022 from '@/components/61_chapter022'
 import A2_CHAPTER023 from '@/components/62_chapter023'
 import A3_CHAPTER024 from '@/components/63_chapter024'
 import A4_CHAPTER025 from '@/components/64_chapter025'
 import A5_CHAPTER026 from '@/components/65_chapter026'
 import A6_CHAPTER027 from '@/components/66_chapter027'
 import A7_CHAPTER028 from '@/components/67_chapter028'
 import A8_CHAPTER029 from '@/components/68_chapter029'
 import A9_CHAPTER0210 from '@/components/69_chapter0210'
 import A0_CHAPTER0211 from '@/components/70_chapter0211'
 import A1_CHAPTER0212 from '@/components/71_chapter0212'
 import A2_CHAPTER0213 from '@/components/72_chapter0213'
 import A3_CHAPTER0214 from '@/components/73_chapter0214'
 import A4_CHAPTER0215 from '@/components/74_chapter0215'
 import A5_CHAPTER0216 from '@/components/75_chapter0216'
 import A6_CHAPTER0217 from '@/components/76_chapter0217'
 import A7_CHAPTER0218 from '@/components/77_chapter0218'
 import A8_CHAPTER03 from '@/components/78_chapter03'
 import A9_CHAPTER031 from '@/components/79_chapter031'
 import A0_CHAPTER032 from '@/components/80_chapter032'
 import A1_CHAPTER033 from '@/components/81_chapter033'
 import A2_CHAPTER034 from '@/components/82_chapter034'
 import A3_CHAPTER035 from '@/components/83_chapter035'
 import A4_CHAPTER036 from '@/components/84_chapter036'
 import A5_CHAPTER037 from '@/components/85_chapter037'
 import A6_CHAPTER038 from '@/components/86_chapter038'
 import A7_CHAPTER039 from '@/components/87_chapter039'
 import A8_CHAPTER0310 from '@/components/88_chapter0310'
 import A9_CHAPTER0311 from '@/components/89_chapter0311'
 import A0_CHAPTER0312 from '@/components/90_chapter0312'
 import A1_CHAPTER0313 from '@/components/91_chapter0313'
 import A2_CHAPTER0314 from '@/components/92_chapter0314'
 import A3_CHAPTER0315 from '@/components/93_chapter0315'
 import A4_CHAPTER0316 from '@/components/94_chapter0316'
 import A5_CHAPTER0317 from '@/components/95_chapter0317'
 import A6_CHAPTER04 from '@/components/96_chapter04'
 import A7_CHAPTER041 from '@/components/97_chapter041'
 import A8_CHAPTER042 from '@/components/98_chapter042'
 import A9_CHAPTER043 from '@/components/99_chapter043'
 import A00_CHAPTER044 from '@/components/100_chapter044'
 import A01_CHAPTER045 from '@/components/101_chapter045'
 import A02_CHAPTER046 from '@/components/102_chapter046'
 import A03_CHAPTER047 from '@/components/103_chapter047'
 import A04_CHAPTER048 from '@/components/104_chapter048'
 import A05_CHAPTER049 from '@/components/105_chapter049'
 import A06_CHAPTER0410 from '@/components/106_chapter0410'
 import A07_CHAPTER0411 from '@/components/107_chapter0411'
 import A08_CHAPTER0412 from '@/components/108_chapter0412'
 import A09_CHAPTER0413 from '@/components/109_chapter0413'
 import A10_CHAPTER0414 from '@/components/110_chapter0414'
 import A11_CHAPTER0415 from '@/components/111_chapter0415'
 import A12_CHAPTER0416 from '@/components/112_chapter0416'
 import A13_CHAPTER0417 from '@/components/113_chapter0417'
 import A14_CHAPTER0418 from '@/components/114_chapter0418'
 import A15_CHAPTER0419 from '@/components/115_chapter0419'
 import A16_CHAPTER0420 from '@/components/116_chapter0420'
 import A17_CHAPTER0421 from '@/components/117_chapter0421'
 import A18_CHAPTER0422 from '@/components/118_chapter0422'
 import A19_CHAPTER0423 from '@/components/119_chapter0423'
 import A20_CHAPTER0424 from '@/components/120_chapter0424'
 import A21_CHAPTER0425 from '@/components/121_chapter0425'
 import A22_CHAPTER0426 from '@/components/122_chapter0426'
 import A23_CHAPTER0427 from '@/components/123_chapter0427'
 import A24_CHAPTER0428 from '@/components/124_chapter0428'
 import A25_CHAPTER0429 from '@/components/125_chapter0429'
 import A26_CHAPTER0430 from '@/components/126_chapter0430'
 import A27_CHAPTER05 from '@/components/127_chapter05'
 import A28_CHAPTER051 from '@/components/128_chapter051'
 import A29_CHAPTER052 from '@/components/129_chapter052'
 import A30_CHAPTER053 from '@/components/130_chapter053'
 import A31_CHAPTER054 from '@/components/131_chapter054'
 import A32_CHAPTER055 from '@/components/132_chapter055'
 import A33_CHAPTER056 from '@/components/133_chapter056'
 import A34_CHAPTER057 from '@/components/134_chapter057'
 import A35_CHAPTER058 from '@/components/135_chapter058'
 import A36_CHAPTER059 from '@/components/136_chapter059'
 import A37_CHAPTER0510 from '@/components/137_chapter0510'
 import A38_CHAPTER0511 from '@/components/138_chapter0511'
 import A39_CHAPTER0512 from '@/components/139_chapter0512'
 import A40_CHAPTER0513 from '@/components/140_chapter0513'
 import A41_CHAPTER0514 from '@/components/141_chapter0514'
 import A42_CHAPTER06 from '@/components/142_chapter06'
 import A43_CHAPTER061 from '@/components/143_chapter061'
 import A44_CHAPTER062 from '@/components/144_chapter062'
 import A45_CHAPTER063 from '@/components/145_chapter063'
 import A46_CHAPTER064 from '@/components/146_chapter064'
 import A47_CHAPTER065 from '@/components/147_chapter065'
 import A48_CHAPTER066 from '@/components/148_chapter066'
 import A49_CHAPTER067 from '@/components/149_chapter067'
 import A50_CHAPTER068 from '@/components/150_chapter068'
 import A51_CHAPTER069 from '@/components/151_chapter069'
 import A52_CHAPTER0610 from '@/components/152_chapter0610'
 import A53_CHAPTER0611 from '@/components/153_chapter0611'
 import A54_CHAPTER07 from '@/components/154_chapter07'
 import A55_CHAPTER071 from '@/components/155_chapter071'
 import A56_CHAPTER072 from '@/components/156_chapter072'
 import A57_CHAPTER073 from '@/components/157_chapter073'
 import A58_CHAPTER074 from '@/components/158_chapter074'
 import A59_CHAPTER075 from '@/components/159_chapter075'
 import A60_CHAPTER076 from '@/components/160_chapter076'
 import A61_CHAPTER077 from '@/components/161_chapter077'
 import A62_CHAPTER078 from '@/components/162_chapter078'
 import A63_CHAPTER079 from '@/components/163_chapter079'
 import A64_CHAPTER0710 from '@/components/164_chapter0710'
 import A65_CHAPTER0711 from '@/components/165_chapter0711'
 import A66_CHAPTER0712 from '@/components/166_chapter0712'
 import A67_CHAPTER0713 from '@/components/167_chapter0713'
 import A68_CHAPTER0714 from '@/components/168_chapter0714'
 import A69_CHAPTER0715 from '@/components/169_chapter0715'
 import A70_CHAPTER0716 from '@/components/170_chapter0716'
 import A71_CHAPTER0717 from '@/components/171_chapter0717'
 import A72_CHAPTER0718 from '@/components/172_chapter0718'
 import A73_CHAPTER0719 from '@/components/173_chapter0719'
 import A74_CHAPTER0720 from '@/components/174_chapter0720'
 import A75_CHAPTER0721 from '@/components/175_chapter0721'
 import A76_CHAPTER0722 from '@/components/176_chapter0722'
 import A77_CHAPTER0723 from '@/components/177_chapter0723'
 import A78_CHAPTER0724 from '@/components/178_chapter0724'
 import A79_CHAPTER0725 from '@/components/179_chapter0725'
 import A80_CHAPTER0726 from '@/components/180_chapter0726'
 import A81_CHAPTER0727 from '@/components/181_chapter0727'
 import A82_CHAPTER0728 from '@/components/182_chapter0728'
 import A83_CHAPTER0729 from '@/components/183_chapter0729'
 import A84_CHAPTER0730 from '@/components/184_chapter0730'
 import A85_CHAPTER0731 from '@/components/185_chapter0731'
 import A86_CHAPTER0732 from '@/components/186_chapter0732'
 import A87_CHAPTER0733 from '@/components/187_chapter0733'
 import A88_CHAPTER0734 from '@/components/188_chapter0734'
 import A89_CHAPTER0735 from '@/components/189_chapter0735'
 import A90_CHAPTER0736 from '@/components/190_chapter0736'
 import A91_CHAPTER0737 from '@/components/191_chapter0737'
 import A92_CHAPTER08 from '@/components/192_chapter08'
 import A93_CHAPTER081 from '@/components/193_chapter081'
 import A94_CHAPTER082 from '@/components/194_chapter082'
 import A95_CHAPTER083 from '@/components/195_chapter083'
 import A96_CHAPTER084 from '@/components/196_chapter084'
 import A97_CHAPTER085 from '@/components/197_chapter085'
 import A98_CHAPTER086 from '@/components/198_chapter086'
 import A99_CHAPTER087 from '@/components/199_chapter087'
 import A00_CHAPTER088 from '@/components/200_chapter088'
 import A01_CHAPTER089 from '@/components/201_chapter089'
 import A02_CHAPTER0810 from '@/components/202_chapter0810'
 import A03_CHAPTER0811 from '@/components/203_chapter0811'
 import A04_CHAPTER0812 from '@/components/204_chapter0812'
 import A05_CHAPTER0813 from '@/components/205_chapter0813'
 import A06_CHAPTER0814 from '@/components/206_chapter0814'
 import A07_CHAPTER0815 from '@/components/207_chapter0815'
 import A08_CHAPTER0816 from '@/components/208_chapter0816'
 import A09_CHAPTER0817 from '@/components/209_chapter0817'
 import A10_CHAPTER0818 from '@/components/210_chapter0818'
 import A11_CHAPTER0819 from '@/components/211_chapter0819'
 import A12_CHAPTER0820 from '@/components/212_chapter0820'
 import A13_CHAPTER09 from '@/components/213_chapter09'
 import A14_CHAPTER091 from '@/components/214_chapter091'
 import A15_CHAPTER092 from '@/components/215_chapter092'
 import A16_CHAPTER093 from '@/components/216_chapter093'
 import A17_CHAPTER094 from '@/components/217_chapter094'
 import A18_CHAPTER095 from '@/components/218_chapter095'
 import A19_CHAPTER096 from '@/components/219_chapter096'
 import A20_CHAPTER097 from '@/components/220_chapter097'
 import A21_CHAPTER098 from '@/components/221_chapter098'
 import A22_CHAPTER099 from '@/components/222_chapter099'
 import A23_CHAPTER0910 from '@/components/223_chapter0910'
 import A24_CHAPTER0911 from '@/components/224_chapter0911'
 import A25_CHAPTER0912 from '@/components/225_chapter0912'
 import A26_CHAPTER0913 from '@/components/226_chapter0913'
 import A27_CHAPTER0914 from '@/components/227_chapter0914'
 import A28_CHAPTER0915 from '@/components/228_chapter0915'
 import A29_CHAPTER0916 from '@/components/229_chapter0916'
 import A30_CHAPTER0917 from '@/components/230_chapter0917'
 import A31_CHAPTER10 from '@/components/231_chapter10'
 import A32_CHAPTER101 from '@/components/232_chapter101'
 import A33_CHAPTER102 from '@/components/233_chapter102'
 import A34_CHAPTER103 from '@/components/234_chapter103'
 import A35_CHAPTER104 from '@/components/235_chapter104'
 import A36_CHAPTER105 from '@/components/236_chapter105'
 import A37_CHAPTER106 from '@/components/237_chapter106'
 import A38_CHAPTER107 from '@/components/238_chapter107'
 import A39_CHAPTER108 from '@/components/239_chapter108'
 import A40_CHAPTER109 from '@/components/240_chapter109'
 import A41_CHAPTER1010 from '@/components/241_chapter1010'
 import A42_CHAPTER1011 from '@/components/242_chapter1011'
 import A43_CHAPTER1012 from '@/components/243_chapter1012'
 import A44_CHAPTER1013 from '@/components/244_chapter1013'
 import A45_CHAPTER1014 from '@/components/245_chapter1014'
 import A46_CHAPTER1015 from '@/components/246_chapter1015'
 import A47_CHAPTER1016 from '@/components/247_chapter1016'
 import A48_CHAPTER1017 from '@/components/248_chapter1017'
 import A49_CHAPTER1018 from '@/components/249_chapter1018'
 import A50_CHAPTER11 from '@/components/250_chapter11'
 import A51_CHAPTER111 from '@/components/251_chapter111'
 import A52_CHAPTER112 from '@/components/252_chapter112'
 import A53_CHAPTER113 from '@/components/253_chapter113'
 import A54_CHAPTER114 from '@/components/254_chapter114'
 import A55_CHAPTER115 from '@/components/255_chapter115'
 import A56_CHAPTER116 from '@/components/256_chapter116'
 import A57_CHAPTER117 from '@/components/257_chapter117'
 import A58_CHAPTER118 from '@/components/258_chapter118'
 import A59_CHAPTER119 from '@/components/259_chapter119'
 import A60_CHAPTER1110 from '@/components/260_chapter1110'
 import A61_CHAPTER1111 from '@/components/261_chapter1111'
 import A62_CHAPTER1112 from '@/components/262_chapter1112'
 import A63_CHAPTER1113 from '@/components/263_chapter1113'
 import A64_CHAPTER1114 from '@/components/264_chapter1114'
 import A65_CHAPTER12 from '@/components/265_chapter12'
 import A66_CHAPTER121 from '@/components/266_chapter121'
 import A67_CHAPTER122 from '@/components/267_chapter122'
 import A68_CHAPTER123 from '@/components/268_chapter123'
 import A69_CHAPTER124 from '@/components/269_chapter124'
 import A70_CHAPTER125 from '@/components/270_chapter125'
 import A71_CHAPTER126 from '@/components/271_chapter126'
 import A72_CHAPTER127 from '@/components/272_chapter127'
 import A73_CHAPTER128 from '@/components/273_chapter128'
 import A74_CHAPTER129 from '@/components/274_chapter129'
 import A75_CHAPTER1210 from '@/components/275_chapter1210'
 import A76_CHAPTER1211 from '@/components/276_chapter1211'
 import A77_CHAPTER1212 from '@/components/277_chapter1212'
 import A78_CHAPTER1213 from '@/components/278_chapter1213'
 import A79_CHAPTER1214 from '@/components/279_chapter1214'
 import A80_CHAPTER1215 from '@/components/280_chapter1215'
 import A81_CHAPTER1216 from '@/components/281_chapter1216'
 import A82_CHAPTER1217 from '@/components/282_chapter1217'
 import A83_CHAPTER1218 from '@/components/283_chapter1218'
 import A84_CHAPTER1219 from '@/components/284_chapter1219'
 import A85_CHAPTER1220 from '@/components/285_chapter1220'
 import A86_CHAPTER1221 from '@/components/286_chapter1221'
 import A87_CHAPTER1222 from '@/components/287_chapter1222'
 import A88_CHAPTER1223 from '@/components/288_chapter1223'
 import A89_READING from '@/components/289_reading'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/03_contents",
 			"name" : "03_contents",
 			"component" : A3_CONTENTS
 		},
 		{
 			"path" : "/04_intro",
 			"name" : "04_intro",
 			"component" : A4_INTRO
 		},
 		{
 			"path" : "/05_fm02",
 			"name" : "05_fm02",
 			"component" : A5_FM02
 		},
 		{
 			"path" : "/06_fm021",
 			"name" : "06_fm021",
 			"component" : A6_FM021
 		},
 		{
 			"path" : "/07_fm022",
 			"name" : "07_fm022",
 			"component" : A7_FM022
 		},
 		{
 			"path" : "/08_fm023",
 			"name" : "08_fm023",
 			"component" : A8_FM023
 		},
 		{
 			"path" : "/09_fm024",
 			"name" : "09_fm024",
 			"component" : A9_FM024
 		},
 		{
 			"path" : "/10_fm025",
 			"name" : "10_fm025",
 			"component" : A0_FM025
 		},
 		{
 			"path" : "/11_fm026",
 			"name" : "11_fm026",
 			"component" : A1_FM026
 		},
 		{
 			"path" : "/12_fm027",
 			"name" : "12_fm027",
 			"component" : A2_FM027
 		},
 		{
 			"path" : "/13_fm028",
 			"name" : "13_fm028",
 			"component" : A3_FM028
 		},
 		{
 			"path" : "/14_fm029",
 			"name" : "14_fm029",
 			"component" : A4_FM029
 		},
 		{
 			"path" : "/15_fm0210",
 			"name" : "15_fm0210",
 			"component" : A5_FM0210
 		},
 		{
 			"path" : "/16_fm0211",
 			"name" : "16_fm0211",
 			"component" : A6_FM0211
 		},
 		{
 			"path" : "/17_fm03",
 			"name" : "17_fm03",
 			"component" : A7_FM03
 		},
 		{
 			"path" : "/18_fm031",
 			"name" : "18_fm031",
 			"component" : A8_FM031
 		},
 		{
 			"path" : "/19_fm032",
 			"name" : "19_fm032",
 			"component" : A9_FM032
 		},
 		{
 			"path" : "/20_fm033",
 			"name" : "20_fm033",
 			"component" : A0_FM033
 		},
 		{
 			"path" : "/21_fm034",
 			"name" : "21_fm034",
 			"component" : A1_FM034
 		},
 		{
 			"path" : "/22_fm035",
 			"name" : "22_fm035",
 			"component" : A2_FM035
 		},
 		{
 			"path" : "/23_fm036",
 			"name" : "23_fm036",
 			"component" : A3_FM036
 		},
 		{
 			"path" : "/24_fm037",
 			"name" : "24_fm037",
 			"component" : A4_FM037
 		},
 		{
 			"path" : "/25_fm038",
 			"name" : "25_fm038",
 			"component" : A5_FM038
 		},
 		{
 			"path" : "/26_fm039",
 			"name" : "26_fm039",
 			"component" : A6_FM039
 		},
 		{
 			"path" : "/27_fm0310",
 			"name" : "27_fm0310",
 			"component" : A7_FM0310
 		},
 		{
 			"path" : "/28_fm0311",
 			"name" : "28_fm0311",
 			"component" : A8_FM0311
 		},
 		{
 			"path" : "/29_fm0312",
 			"name" : "29_fm0312",
 			"component" : A9_FM0312
 		},
 		{
 			"path" : "/30_fm0313",
 			"name" : "30_fm0313",
 			"component" : A0_FM0313
 		},
 		{
 			"path" : "/31_fm0314",
 			"name" : "31_fm0314",
 			"component" : A1_FM0314
 		},
 		{
 			"path" : "/32_fm04",
 			"name" : "32_fm04",
 			"component" : A2_FM04
 		},
 		{
 			"path" : "/33_fm041",
 			"name" : "33_fm041",
 			"component" : A3_FM041
 		},
 		{
 			"path" : "/34_fm042",
 			"name" : "34_fm042",
 			"component" : A4_FM042
 		},
 		{
 			"path" : "/35_fm043",
 			"name" : "35_fm043",
 			"component" : A5_FM043
 		},
 		{
 			"path" : "/36_fm044",
 			"name" : "36_fm044",
 			"component" : A6_FM044
 		},
 		{
 			"path" : "/37_fm045",
 			"name" : "37_fm045",
 			"component" : A7_FM045
 		},
 		{
 			"path" : "/38_chapter01",
 			"name" : "38_chapter01",
 			"component" : A8_CHAPTER01
 		},
 		{
 			"path" : "/39_chapter011",
 			"name" : "39_chapter011",
 			"component" : A9_CHAPTER011
 		},
 		{
 			"path" : "/40_chapter012",
 			"name" : "40_chapter012",
 			"component" : A0_CHAPTER012
 		},
 		{
 			"path" : "/41_chapter013",
 			"name" : "41_chapter013",
 			"component" : A1_CHAPTER013
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js